import { render, staticRenderFns } from "./TranslatableInput.vue?vue&type=template&id=7730dc9d"
import script from "./TranslatableInput.vue?vue&type=script&lang=js"
export * from "./TranslatableInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports